// extracted by mini-css-extract-plugin
module.exports = {"editSubmitter":"editSubmitter_editSubmitter__29pjY","customPadding":"editSubmitter_customPadding__1cQZ0"};